<template>
  <div id="RememberPassword" class="remember-password-page">
    <loading v-if="loadingRender"></loading>
    <net-pa-list-page-card
      :title="pageTitle"
      :description="pageDescription"
      :show-back="true"
      wrap-class="netpa-list-page-card-wrap--inset netpa-list-page-card-wrap--centered no-print"
    >
      <div class="remember-password-content py-3 px-2">
        <form v-if="stage == 1" id="div1" class="remember-password-form">
          <div class="remember-password-field">
            <input
              class="form-control text-center required"
              dir="ltr"
              type="number"
              v-model="Codemeli"
              placeholder="کد ملی"
              @keypress="$BlockSuspiciousInput($event, 11)"
              @keyup="$BlockSuspiciousInput($event, 12)"
            />
          </div>
          <div class="remember-password-field">
            <input
              class="form-control text-center required"
              dir="ltr"
              type="number"
              v-model="mobile"
              placeholder="شماره موبایل"
              @keypress="$BlockSuspiciousInput($event, 11)"
              @keyup="$BlockSuspiciousInput($event, 12)"
            />
          </div>
          <div class="remember-password-field">
            <CaptchaBox ref="captchaRef" @update="onCaptchaValid"></CaptchaBox>
          </div>
          <div class="remember-password-actions">
            <button
              type="button"
              :disabled="!CaptchaValid"
              class="btn btn-success remember-password-submit-btn"
              @click.prevent="sendSms"
            >
              ارسال پیامک بازیابی
            </button>
          </div>
        </form>

        <form v-else id="divpass" class="remember-password-form">
          <div class="remember-password-field">
            <input
              type="number"
              placeholder="کد یکبار مصرف"
              class="form-control text-center required"
              dir="ltr"
              v-model="yekbarRamz"
              autocomplete="off"
            />
          </div>
          <div class="remember-password-field remember-password-field--password">
            <input
              :type="showPass ? 'text' : 'password'"
              placeholder="رمز عبور جدید"
              class="form-control text-center required required-Pass"
              dir="ltr"
              v-model="newPass"
              @keypress="$BlockSuspiciousInput($event, 30)"
              autocomplete="new-password"
            />
            <span @click="showPass = !showPass" class="remember-password-toggle-eye">
              <i v-if="showPass" class="fa fa-eye-slash"></i>
              <i v-else class="fa fa-eye"></i>
            </span>
          </div>
          <div class="remember-password-field remember-password-field--password">
            <input
              :type="showPass2 ? 'text' : 'password'"
              placeholder="تکرار رمز عبور"
              class="form-control text-center required required-Pass"
              dir="ltr"
              v-model="NewPassRepeat"
              @keypress="$BlockSuspiciousInput($event, 30)"
              @keyup="$BlockSuspiciousInput($event, 30)"
              autocomplete="new-password"
            />
            <span @click="showPass2 = !showPass2" class="remember-password-toggle-eye">
              <i v-if="showPass2" class="fa fa-eye-slash"></i>
              <i v-else class="fa fa-eye"></i>
            </span>
          </div>
          <div class="remember-password-field">
            <CaptchaBox ref="captchaRef" @update="onCaptchaValid"></CaptchaBox>
          </div>
          <div class="remember-password-actions">
            <button
              type="button"
              :disabled="!CaptchaValid"
              class="btn btn-success remember-password-submit-btn"
              @click.prevent="changepass"
            >
              تغییر رمز
            </button>
          </div>
        </form>
      </div>
    </net-pa-list-page-card>
  </div>
</template>

<script>
import NetPaListPageCard from "../Tools/NetPa/NetPaListPageCard.vue";
import loading from "../Tools/NetPa/Loading.vue";
import CaptchaBox from "../CmpLogin/CaptchaBox.vue";

export default {
  components: { NetPaListPageCard, loading, CaptchaBox },
  data() {
    return {
      showPass: false,
      showPass2: false,
      captchaText: "",
      captchaId: "",
      CaptchaValid: false,
      mobile: "",
      Codemeli: "",
      stage: 1,
      validation: false,
      NewPassRepeat: "",
      newPass: "",
      yekbarRamz: "",
      loadingRender: false,
    };
  },
  computed: {
    pageTitle() {
      return this.stage === 1 ? "بازیابی رمز عبور" : "تغییر رمز عبور";
    },
    pageDescription() {
      if (this.stage === 1) {
        return "برای دریافت پیامک بازیابی، کد ملی و شماره موبایل ثبت‌شده در سیستم را وارد کنید";
      }
      return "کد پیامک‌شده و رمز عبور جدید خود را وارد کنید";
    },
  },
  methods: {
    onCaptchaValid({ valid, captchaId, userInput }) {
      this.CaptchaValid = valid;
      this.captchaId = captchaId;
      this.captchaText = userInput;
    },
    refreshCaptcha() {
      this.$refs.captchaRef.generateCaptcha();
    },
    sendSms() {
      if (this.$ValidForm("div1")) {
        if (this.Codemeli == "") {
          this.refreshCaptcha();
          this.$mySweetDefaultTost(
            "خطا",
            " کد ملی نمیتواند خالی باشد.",
            "error",
            2000,
          );
          return;
        }
        if (this.mobile == "") {
          this.refreshCaptcha();
          this.$mySweetDefaultTost(
            "خطا",
            "  شماره همراه نمیتواند خالی باشد.",
            "error",
            2000,
          );
          return;
        }
        if (this.mobile.length != 11) {
          this.refreshCaptcha();
          this.$mySweetDefaultTost(
            "خطا",
            "  شماره همراه 11 رقمی است.",
            "error",
            2000,
          );
          return;
        } else {
          this.loadingRender = true;
          var DataAxiosForget = {
            ArryfildValue: {},
            Action: "Bazyabi/RememberPass",
            Method: "POST",
            Token: "",
          };
          const formData = new FormData();
          formData.append("mobile", this.mobile);
          formData.append("codeMeli", this.Codemeli);
          formData.append("userInput", this.captchaText);
          formData.append("captchaId", this.captchaId);
          DataAxiosForget.ArryfildValue = formData;
          this.$PostFormData(DataAxiosForget).then((data) => {
            this.$mySweetDefaultTost(" ", data.msg, data.icone, 3000);
            if (data.status == "Ok") {
              this.stage = 2;
              this.loadingRender = false;
              this.CaptchaValid = false;
              this.$nextTick(() => this.refreshCaptcha());
            } else {
              this.refreshCaptcha();
              this.stage = 1;
              this.loadingRender = false;
            }
          });
        }
      }
    },
    changepass() {
      if (this.$ValidForm("divpass")) {
        this.loadingRender = true;
        if (this.newPass == this.NewPassRepeat) {
          var DataAxiosChangePass = {
            ArryfildValue: {},
            Action: "Bazyabi/UpdatePass",
            Method: "POST",
            Token: "",
          };
          const formData = new FormData();
          formData.append(
            "AxarinTaghirPass",
            this.$store.state.JalaliDateAndTime,
          );
          formData.append("newPass", this.newPass);
          formData.append("randomKey", this.yekbarRamz);
          formData.append("codeMeli", this.Codemeli);
          formData.append("CustomerCode", this.$session.get("CustCode"));
          formData.append("userInput", this.captchaText);
          formData.append("captchaId", this.captchaId);
          DataAxiosChangePass.ArryfildValue = formData;
          this.$PostFormData(DataAxiosChangePass).then((data) => {
            this.$mySweetDefaultTost(" ", data.msg, data.icone, 2000);
            if (data.status == "Ok") {
              this.$router.go(-1);
            } else {
              this.refreshCaptcha();
              this.loadingRender = false;
              this.stage = 2;
            }
          });
        } else {
          this.loadingRender = false;
          this.$mySweetDefaultTost(
            " خطا",
            "رمز عبور وارد شده و تکرارش برابر نیستند!",
            "error",
            2000,
          );
          return;
        }
      }
    },
    checkregex(e) {
      let char = String.fromCharCode(e.keyCode);
      if (!/^[A-Za-z0-9]+$/.test(char)) {
        this.$mySweetDefaultTost(
          "خطا",
          "فقط حروف انگلیسی و اعداد  مجاز هستند",
          "error",
          2000,
        );
        e.preventDefault();
      }
    },
  },
  mounted() {
    this.NewPassRepeat = "";
    this.newPass = "";
    this.yekbarRamz = "";
  },
};
</script>

<style scoped>
.remember-password-content {
  width: 100%;
}

.remember-password-form {
  width: 100%;
  max-width: 520px;
  margin: 0 auto;
  direction: rtl;
}

.remember-password-field {
  margin-bottom: 0.75rem;
}

.remember-password-field--password {
  position: relative;
}

.remember-password-toggle-eye {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #6c757d;
  font-size: 16px;
}

.remember-password-actions {
  margin-top: 1rem;
}

.remember-password-submit-btn {
  width: 100%;
  min-height: 40px;
  border-radius: 8px;
  font-weight: 600;
}
</style>

<style>
input.inputValidetaEh {
  display: block !important;
  width: 100% !important;
  height: calc(1.5em + 0.75rem + 2px) !important;
  padding: 0.375rem 0.75rem !important;
  font-size: 1rem !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
  color: #495057 !important;
  background-color: #fff !important;
  background-clip: padding-box !important;
  border: 1px solid #ced4da !important;
  border-radius: 0.25rem !important;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
}

.LeftsideValideta {
  float: none !important;
}
</style>
